<template>
    <div class="mainPage">
        <div class="header_banner">
            <!-- <img src="../img/cio/m_cio_banner.png" alt="" class="bg"> -->
            <div class="header">
                <div class="titleCon">
                    <img src="../img/russia_business/CELC-w.png" alt="CELC" class="logo">
                    <img src="../img/russia_business/dalianligong.png" alt="" class="logo">
                    <!-- <div class="menuYear" @click="showMemu = !showMemu">
                        {{currentMenu}}
                        <span class="caret" :class="{'activeCaret': showMemu}"></span>
                        <div class="menuList"  :class="{'menuActive': showMemu}">
                            <span :class="{'active': currentMenu == 2022}" @click="changePage(2022)">2022</span>
                            <span :class="{'active': currentMenu == 2021}" @click="changePage(2021, 'https://z.chineseplus.net/dist/#/pcpage/chineseplus_classlive')">2021</span>
                            <span :class="{'active': currentMenu == 2020}" @click="changePage(2020, 'https://z.chineseplus.net/cio_classlive.html')">2020</span>
                        </div>
                    </div> -->
                    <div class="languageCon">
                        <!-- <language ></language> -->
                    </div>
                    <div class="memuCon">
                        <img src="../img/chinesebridge/menu.png" alt="" @click="toggleMenu()">
                        <div class="menu" v-show="activeMenu">
                            <div class="menuUserName" v-if="isLogin">{{user.username}}</div>
                            <div class="logOut" v-if="isLogin" @click="toLogOut()">退出</div>
                            <div class="menuUserName" v-if="!isLogin" @click="toLogin()">登录</div>
                            <div class="logOut" v-if="!isLogin" @click="toLogin()">注册</div>
                        </div>
                    </div>
                </div>
                <div class="content">
                
                  <div class="centerBg">
                    <img src="../img/russia_business/m_info.png" alt="" class="left">
                  </div>
                </div>
                <!-- <div>
                  <img src="../img/2022chinesepluslive/bg_right.png" alt="" class="right_bg">
                </div> -->
            </div>
        </div>
        <div class="tabCon">
            <div class="currentClass" @click="showAllClass = true">{{ activeTab }} 班 группа {{ activeTab }} <span class="caret"></span></div>
            <div>
                <div class="tabBtn" :class="{'activeTab': activeTab == item}" @click="changeTab(item)" v-for="item in classList" :key="item">
                    <div>{{ item }} 班 группа {{ item }}</div>
                </div>
                
            </div>
        </div>
        <div class="courseListCon">
            <ul class="list">
                <li v-for="(item, index) in courseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
                    <div class="timeCon" >
                        <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                        <span class="status live" v-if="item.customStatus == 1">
                            {{ $t('message.classLive') }}
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            {{ $t('message.classFinished') }}
                        </span>
                    </div>
                    <div class="nameCon">
                        <div class="name">
                            <span>
                                {{item.name}}
                            </span>
                        </div>
                        <!-- <div class="name name_en" v-if="language == 'en'">
                            <span>
                                {{item.name_en}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="language == 'es'">
                            <span>
                                {{item.name_es}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="language == 'fr'">
                            <span>
                                {{item.name_fr}}
                            </span>
                        </div> -->
                        <div class="name name_en" >
                            <span>
                                {{item.name_ru}}
                            </span>
                        </div>
                    </div>
                    <div class="titleCon">
                        <div class="title">
                            <div class="cn">
                                {{item.teacher_name}}
                            </div>
                            <!-- <div class="en" v-if="language == 'en'">
                                <span v-if="item.teacher_name_en">
                                    {{item.teacher_name_en}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                            <div class="en" v-if="language == 'es'">
                                <span v-if="item.teacher_name_es">
                                    {{item.teacher_name_es}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                            <div class="en" v-if="language == 'fr'">
                                <span v-if="item.teacher_name_fr">
                                    {{item.teacher_name_fr}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                            <div class="en" v-if="language == 'ru'">
                                <span v-if="item.teacher_name_ru">
                                    {{item.teacher_name_ru}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div> -->
                        </div>
                        <div class="liveBtn">
                            <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    {{ $t('message.join') }}
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                <span class="En">
                                    {{ $t('message.playBack') }}
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                {{ $t('message.classnNoBegin') }}
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    {{ $t('message.enter') }}
                                </span>
                            </span>
                        </div>
                    </div>
                </li>
                <div class="noMore">
                    <span>
                        没有更多了 No more  ...
                    </span>
                </div>
            </ul>
        </div>
        <!-- <div class="guideModel" v-if="isShowGuide">
            <div class="close" @click="isShowGuide = false">×</div>
            <a href="https://z.chineseplus.net/dist/#/m_page/m_guide" target="_blank"><img src="../img/cio/chineseplus_guide.png" alt=""></a>
        </div> -->
        <van-action-sheet
          v-model="showAllClass"
          :actions="className"
          cancel-text="取消"
          close-on-click-action
          @select="changeTab"
        />
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import language from './common/language'
export default {
    name: 'chinesebridge',
    components: {
      language
    },
    data: function () {
        return {
            showAllClass: false,
            classList: [
              1,2,3,4,5,6,7,8,9,10,11,12,13,14,15
            ],
            showMemu: false,
            currentMenu: 2022,
            activeMenu: false,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            activeTab: 1,
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    computed: {
        language () {
            return this.$i18n.locale
        },
        className() {
          let allClass = []
          for (let index = 0; index < this.classList.length; index++) {
            const element = this.classList[index];
            var data = {
              name:  `${element} 班 группа ${element}`,
              index: element
            }
            allClass.push(data)
          }
          return allClass
        },
    },
    methods: {
        changePage(page, url) {
            // this.currentMenu = page
            if(url) {
                window.open(url); 
            }
        },
        changeTab(tab) {
            this.activeTab = tab.index
            this.getSubjectInfo('dalianligong-'+this.activeTab)
        },
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                // this.getCourseInfo(this.subject_id)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.courseList = []
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    this.courseList = res.data.data.list
                    this.categoryName()
                    console.log(this.courseList)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        categoryName() {
            this.courseList.forEach(e => {
                if(e.name.indexOf('HSK标准会话教程2') > -1) {
                    e.category = 1
                }else if(e.name.indexOf('HSK标准会话教程3') > -1) {
                    e.category = 2
                }else if(e.name.indexOf('汉语口语速成-中级篇') > -1) {
                    e.category = 3
                }
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            if(!item.isOrder) {
                this.join(item, index, true)
            }else {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url) {
            this.isPlay = true
            this.currentVideoUrl = url
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        // this.subject_id = 116 // 停课不停学固定id：116
        this.customCheckLogin()
        this.getSubjectInfo('dalianligong-'+this.activeTab)
        // let activeTab = this.$route.query.tab
        // if(activeTab) {
        //     this.activeTab = activeTab
        // }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
    .header_banner {
        width: 100%;
        height: 4.93rem;
    //     background-image: linear-gradient(0deg, 
		// #ffffff 0%, 
		// #cad9ff 100%), 
    //     linear-gradient(
    //         #6187d6, 
    //         #6187d6);
    //     background-blend-mode: normal, 
		// normal;
        background-image: url(../img/russia_business/m_russia_banner.png);
        background-size: cover;
        position: relative;
        overflow: hidden;
        .bg {
            width: 100%;
            height: 4.93rem;
        }
        .header {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1; 
            text-align: left;
            .titleCon {
              line-height: 0.4rem;
              .logo {
                position: relative;
                top: 0.25rem;
                margin-left: 0.2rem;
                height: 0.45rem;
              }
            }
            .title {
              font-size: 0.38rem;
              color: #fff;
              margin-left: 0.48rem;
            }
            .menuYear {
                position: absolute;
                left: 0.2rem;
                top: 0.18rem;
                font-size: 0.3rem;
                z-index: 5;
                padding: 0.04rem 0.08rem 0.04rem 0.08rem;
                border-radius: 0.1rem;
                color: #fd9c29;
                // font-weight: bold;
                background-color: #fff;
                cursor: pointer;
                .caret {
                    display: inline-block;
                    width: 0;
                    height: 0;
                    margin-bottom: 3px;
                    margin-left: 3px;
                    vertical-align: middle;
                    border-top: 6px dashed;
                    border-top: 6px solid\9;
                    border-right: 6px solid transparent;
                    border-left: 6px solid transparent;
                    opacity: .9;
                }
                .activeCaret {
                    border-top: none;
                    border-bottom: 6px dashed;
                }
                .menuList {
                    position: absolute;
                    width: 100%;
                    top: 0.56rem;
                    font-size: 0.3rem;
                    left: 0;
                    color: #282828;
                    font-weight: normal;
                    background-color: #fff;
                    border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
                    box-shadow: 0 0.02rem 0.12rem 0 rgba(0,0,0,0.2);
                    transition: all linear 0.2s;
                    height: 0;
                    overflow:hidden;
                    span {
                        display: block;
                        padding: 0.1rem 0.08rem 0.1rem 0.08rem;
                        border-bottom: 1px solid #ccc;
                    }
                    .active {
                        color: #fd9c29;
                    }
                }
                .menuActive {
                    height: 1.8rem;
                }
            }
            .languageCon {
              position: absolute;
              right: 0.8rem;
              top: 0.21rem;
              font-size: 0;
              z-index: 5;
            }
            .memuCon {
                position: absolute;
                right: 0.33rem;
                top: 0.21rem;
                font-size: 0;
                z-index: 5;
                img {
                    width: 0.4rem;
                }
                .menu {
                    position: absolute;
                    right: 0;
                    top: 0.55rem;
                    background-color: #fff;
                    width: 100px;
                    border-radius: 0.05rem;
                    padding: 0.1rem 0;
                    font-size: 0.3rem;
                    div {
                        color: #333;
                        text-align: center;
                        line-height: 200%;
                    }
                }
            }
            .right_bg {
              position: absolute;
              right: 0.2rem;
              top: 0;
              bottom: 0;
              margin: auto;
              width: 65%;
              opacity: 0.2;
            }
            .content {
                width: 100%;
                height: 100%;
                position: relative;
                .centerBg {
                  text-align: center;
                }
                .left {
                    display: inline-block;
                    width: 90%;
                    left: 0;
                    right: 0;
                    margin: auto;
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    text-align: center;
                    // left: 10%;
                    transform: translateY(-50%);
                    .camp {
                        width: 64%;
                    }
                    .schoolInfo {
                        .logo {
                            height: 0.83rem;
                            margin-top: 0.23rem;
                        }
                        .name {
                            width: 100%;
                            padding: 0 0.68rem 0 0.5rem;
                            font-size: 0.8rem;
                            line-height: 1.2;
                            box-sizing: border-box;
                            text-align: left;
                            color: #fff;
                            font-weight: bold;
                            margin-top: 0.1rem;
                        }
                        .name_1 {
                          font-size:0.46rem;
                          font-weight: normal;
                        }
                        .name_en {
                            width: 100%;
                            font-size: 0.46rem;
                            padding: 0 0.5rem;
                            box-sizing: border-box;
                            text-align: left;
                            font-family: "DINCond-Medium";
                            color: #fff;
                            margin-top: 0.26rem;
                        }
                    }
                }
                
            }
        }
    }
    .tabCon {
        // width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        height: 0.9rem;
        line-height: 0.9rem;
        background-color:#fff;
        padding: 0 0.4rem;
        box-shadow: 0px 3px 5px 0px
		rgba(0, 0, 0, 0.1);
        white-space: nowrap;
        .currentClass {
          color: rgb(63, 112, 222);
          font-weight: bold;
          text-align: left;
        }
        .caret {
            float: right;
            display: inline-block;
            width: 0;
            height: 0;
            margin-top: 0.4rem;
            // margin-right: 15px;
            vertical-align: middle;
            border-top: 6px dashed;
            border-top: 6px solid\9;
            border-right: 6px solid transparent;
            border-left: 6px solid transparent;
            opacity: .9;
        }
        .activeCaret {
            border-top: none;
            border-bottom: 6px dashed;
        }
        >div {
            // width: 1200px;
            margin: auto;
        }
        .tabBtn {
            // display: inline-block;
            margin-right: 0.25rem;
            font-size: 0.4rem;
            cursor: pointer;
            text-align: left;
            vertical-align: top;
            div:last-child {
                font-size: 0.32rem;
                font-family: "DIN-Regular";
            }
        }
        .tabBtn_1 {
          div:last-child {
                font-size: 0.22rem;
                font-family: "DIN-Regular";
                margin-left: 0.1rem;
            }
        }
        .activeTab {
            position: relative;
            color: #f56821;
            :after {
                position: absolute;
                bottom: 0;
                left:0;
                right: 0;
                margin: auto;
                display:inline-block;
                content: '';
                width: 70%;
                height: 0.1rem;
                background-color: #f56821;
            }
        }
        
    }
    .courseListCon {
        margin: auto;
        background-color:#fff;
        .liveClass {
            padding-top: 0.25rem;
            width: 100%;
            text-align: center;
            img {
                width: 2.78rem;
            }
        }
        .list {
            position: relative;
            padding: 0 0.14rem;
            text-align: left;
            margin-top: 0.67rem;
            &:before {
                position: absolute;
                left: 0.16rem;
                width: 0.08rem;
                height: calc(100% + 1rem);
                content: '';
                background-color: #fd9c29;
            }
            li {
                margin-left: 0.42rem;
                margin-bottom: 1.1rem;
                position: relative;
                &:before {
                    position: absolute;
                    left: -0.48rem;
                    content: '';
                    width: 0.24rem;
                    height: 0.24rem;
                    box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 100%;
                    border: 0.06rem solid #fd9c29;
                    background-color: #fad46b;
                }
                .timeCon {
                    font-size: 0;
                    .time {
                        font-size: 0.28rem;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                        vertical-align: top;
                    }
                    .live {
                        float: right;
                        font-size: 0.21rem;
                        color: #379346;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                    .finished {
                        float: right;
                        font-size: 0.21rem;
                        color: #93a4aa;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                }
                .nameCon {
                    margin-top: 0.26rem;
                    margin-bottom: 0.3rem;
                    font-size: 0.28rem;
                    .name {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #364347;
                    }
                    .name_en {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                    }
                }
                .titleCon {
                    font-size: 0.25rem;
                    height: 0.6rem;
                    width: 100%;
                    .title {
                        color: #fd9c29;
                        display: inline-block;
                        width: calc(100% - 2.5rem);
                        .en {
                            font-size: 0.25rem;
                            font-family: 'Georgia';
                            margin-bottom: 0.02rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 0.25rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 0.6rem;
                            line-height: 1.2;
                            border-radius: 0.28rem;
                            background-color: #fd9c29;
                            color: #fff;
                            padding: 0.15rem 0.22rem;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 0.26rem;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 0.24rem;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #4a88da;
                            color: #fff;
                        }
                        .isOrder {
                            color: #999;
                            font-size: 0.24rem;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
            .noMore {
                font-size: 0.25rem;
                margin-left: 0.4rem;
                color: #7ecef4;
                position: relative;
            }
            .noMore:after {
                position: absolute;
                right: 0;
                z-index: 1;
                top: 0.18rem;
                display: inline-block;
                content: '';
                height: 0.03rem;
                width: calc(100% - 2.8rem);
                background-color: #7ecef4;
            }
        }
    }
    .guideModel {
        position: fixed;
        right: 0;bottom: 40px;
        z-index: 5;
        cursor: pointer;
        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 100%;
    }
}

</style>
